import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router";
import Loader from "../../Loader/Loader";
import { Snackbar } from "../../utils/snackbar";
import { category, addsubcategory } from "../../services/Mainservice";
// import addimg from "../../assets/image.png";
import { Plus } from "lucide-react";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Required";
  }
  if (!values.type) {
    errors.type = "Required";
  }
  if (!values.preview) {
    errors.preview = "Required";
  }
  return errors;
};

const Addsubcategory = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [cat, setcat] = useState([]);
  const [image, setImage] = useState();

  const navigate = useNavigate();
  const handleClose = (event, reason) => {
    setOpen(false);
  };

  useEffect(() => {
    getcategory();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
      preview: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const getcategory = async () => {
    try {
      const responce = await category();
      console.log(responce);
      setcat(responce.data.data);
      formik.setFieldValue("type", responce.data.data[0].id);
    } catch (error) {
      console.log(error);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addsubcategory(values.type, values.name, image);
      navigate("/Subcategory_List");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handleupload = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      formik.setFieldValue("preview", URL.createObjectURL(e.target.files[0]));
    } else {
      console.log("No file selected");
    }
  };
  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Subcategory</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Subcategory Name</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              placeholder="Catgeory Name"
              minLength={1}
              maxLength={200}
              //   value={data.name}
              className="Auth_input"
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Category Type</label>
            <br />
            <select
              onChange={formik.handleChange}
              name="type"
              className="Auth_input"
              value={formik.values.type}
              style={{ width: "94%" }}
            >
              {cat.map((i) => (
                <option value={i.id}>{i.Name}</option>
              ))}
            </select>
            {formik.errors.type ? (
              <p className="invalid">{formik.errors.type} </p>
            ) : null}
          </div>

          <div>
            <label htmlFor="img">
              <p className="Auth_label">Subcategory Image</p>

              {formik.values.preview ? (
                <img
                  src={formik.values.preview}
                  alt="image"
                  className="editprofile_image"
                />
              ) : (
                <>
                  <div className="addbox_image" style={{ cursor: "pointer" }}>
                    <Plus style={{ color: "var(--white" }} />
                    {/* <img src={addimg} alt="add image" /> */}
                  </div>
                </>
              )}
            </label>
            <input
              onChange={handleupload}
              id="img"
              name="img"
              type="file"
              className="Auth_input"
              style={{ display: "none" }}
            />
            {formik.errors.preview ? (
              <p className="invalid">{formik.errors.preview} </p>
            ) : null}
          </div>
          <div />
          <button className="term_button" type="Submit">
            {load ? "Adding..." : "Save"}
          </button>
        </form>
      </div>
      {load && <Loader />}
      <Snackbar
        open={open}
        severity="error"
        onclose={handleClose}
        message={err}
      />
    </>
  );
};
export default Addsubcategory;
